import { ref } from 'vue';

const employeeSettingProfilesHandling = () => {
    const employeeSettingProfiles_error = ref(null);
    const employeeSettings = ref(null);

    const attachSettingProfile = async (employeeId, modelId, modelName, startAt) => {

        const tokenResponse = await fetch('/sanctum/csrf-cookie', {
            method: 'GET',
            credentials: 'include'
        });
        const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

        const requestOptions = {
            method: 'PUT',
            headers: {
                'X-XSRF-TOKEN': token,
                'Content-Type': 'application/json',
                'accept': 'application/json',
            },
            body: JSON.stringify({
                employee_id: employeeId,
                model_id: modelId,
                model_name: modelName,
                start_at: startAt,
            })
        };

        try {
            const response = await fetch('/api/employees/' + employeeId + '/settingprofiles', requestOptions);
            //console.log(requestOptions);
            if (!response.ok) {
                //console.log('composable response not ok: ' , response.status + ' - ' + response.statusText);
                employeeSettingProfiles_error.value = response.status + ' - ' + response.statusText;
            }
            const data = await response.json();
            //console.log('composable data: ' , data);
            return data;

        } catch (err) {
            employeeSettingProfiles_error.value = err.message;
            console.log('composable error: ', err.message);
        }

        //console.log('composable gelangte hinter try catch');
    }

    const loadEmployeeSettings = async (employeeId, settingtype) => {
        try {
            var params = [
                ['employee_id', employeeId],
                ['settingtype', settingtype],
            ];

            const tokenResponse = await fetch('/sanctum/csrf-cookie', {
                method: 'GET',
                credentials: 'include'
            });
            const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

            const requestOptions = {
                headers: {
                    'X-XSRF-TOKEN': token,
                    'Content-Type': 'application/json',
                    'accept': 'application/json',
                }
            };

            let data = null;
            if (settingtype == 'FlextimeProfile') {
                data = await fetch("/api/employees/" + employeeId + "/flextimeprofiles", requestOptions);
            } else {
                data = await fetch("/api/employees/" + employeeId + "/settings?" + new URLSearchParams(params));
            }

            if (!data.ok) {
                throw Error("Can't load data");
            }

            employeeSettings.value = await data.json();

            console.log('employeeSettings', employeeSettings.value);
        } catch (err) {
            console.log(err);
            employeeSettingProfiles_error.value = err.message;
        }
    }

    return { employeeSettingProfiles_error, attachSettingProfile, employeeSettings, loadEmployeeSettings };

};

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
};


export default employeeSettingProfilesHandling;
